export const LayoutType = {
  Layout1: 1,
  Layout2: 2,
};

export const LayoutAbbreviation = {
  All: "ALL",
  Layout1: "Layout1",
  Layout2: "Layout2",
};

export const LayoutAbbreviations = [
  "Layout1",
  "Layout2",
];
export const LayoutAbbreviationsToRemove = [
  "Layout2",
  "Layout1",
];

export const METADATA = {
  ALL: "ALL"
};

export const DECORS_MAX = 10;
